import React, { memo, useEffect, useState, useRef, useCallback } from "react";
import type { ElasticSearchResourceResponse } from "types";
import type { QueryBuilderEntityProps } from "./types";
import Resource from "ui/layouts/Resource";
import QueryBuilder, {
    FormFields,
    type FormValues,
    type QueryBuilderForm
} from "ui/forms/QueryBuilder";
import QueryBuilderDisplayPayload from "./QueryBuilderDisplayPayload";
import { useSimpleRequest } from "hooks/useRequest";
import QueryBuilderPaginator from "./QueryBuilderPaginator";

const QueryBuilderEntity = ({ label, query }: QueryBuilderEntityProps) => {
    const [data, setData] = useState<ElasticSearchResourceResponse<string>['data']>();
    const [isLoading, setLoading] = useState<boolean>(false);

    const request = useSimpleRequest({
        setLoading
    });

    const onSubmit = async (formValues: FormValues) => {
        await request(() => query(`?${formValues[FormFields.SearchQuery]}`), {
            onSuccess: ({ data }: ElasticSearchResourceResponse<string>) => setData(data)
        });
    };

    const helpers = {
        data,
        onSubmit
    };
    const helpersRef = useRef(helpers);
    helpersRef.current = helpers;

    const renderChildren = useCallback((queryBuilderForm: QueryBuilderForm) => (
        <QueryBuilderPaginator
            {...queryBuilderForm}
            {...helpersRef.current}
        />
    ), []);

    useEffect(() => {
        helpersRef.current.onSubmit({ [FormFields.SearchQuery]: '' });
    }, []);

    let mappedData = null;

    try {
        // @ts-ignore
        if ('columns' in data) {
            // @ts-ignore
            globalThis.elasticSearchResonseColumns = data.columns;

            // @ts-ignore
            if (globalThis.elasticSearchConditionColumns === undefined) {
                // @ts-ignore
                globalThis.elasticSearchConditionColumns = data.columns;

            }
        }

        // @ts-ignore
        mappedData = {"total_rows": data.total_rows, "cursor": ''};
        // @ts-ignore
        if ('cursor' in data) {
            mappedData.cursor = data.cursor
        }
        // @ts-ignore
        mappedData['data'] = data.rows.map((row: array): array => {
            let mappedRow = {};
            row.forEach((value: any, index: string | number): void => {
                // @ts-ignore
                mappedRow[globalThis.elasticSearchResonseColumns[index].name] = value;
            });

            return mappedRow;
        });
    } catch (e) {
    }

    return (
        <Resource
            title={`Query builder | ${label}`}
            breadcrumbsProps={{
                heading: 'Query builder',
                links: [
                    { name: String(label) }
                ]
            }}
        >
            <QueryBuilder
                isLoading={isLoading}
                label={label}
                onSubmit={onSubmit}
                renderChildren={renderChildren}
            />
            <QueryBuilderDisplayPayload
                data={(mappedData ?? data) ?? null}
                isLoading={isLoading}
            />
        </Resource>
    );
};

export default memo(QueryBuilderEntity);
